export default __webpack_public_path__ + "static/media/contract-logo-header.6afee9a1.svg";